"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

exports.__esModule = true;
exports.ByStationCodec = void 0;

var t = __importStar(require("io-ts")); // Example response:
// Object {
//   "d": Array [
//     Object {
//       "d": 0.8,
//       "geo": Array [
//         52.489451,
//         13.430844,
//       ],
//       "key": "_c08tyk3Mq9R3Si3KyczT90stzT68LScnT9cvMa84Na-4pCjx8PxUAA",
//       "nlo": "Neukölln-Nansenstraße, Berlin",
//       "nna": "",
//       "pol": "pm25",
//       "t": 1533819600,
//       "u": "Germany/Berlin/Neukölln-Nansenstraße",
//       "v": "75",
//       "x": "10032",
//     },
//   ],
//   "g": null,
// }


exports.ByStationCodec = t.type({
  d: t.array(t.type({
    d: t.number,
    geo: t.tuple([t.number, t.number]),
    key: t.string,
    nlo: t.string,
    nna: t.string,
    pol: t.string,
    t: t.number,
    u: t.string,
    v: t.string,
    x: t.string
  })),
  g: t.any
});